import { render, staticRenderFns } from "./EditUserForm.vue?vue&type=template&id=f85d6664"
import script from "./EditUserForm.vue?vue&type=script&lang=js"
export * from "./EditUserForm.vue?vue&type=script&lang=js"
import style0 from "./EditUserForm.vue?vue&type=style&index=0&id=f85d6664&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports